/* eslint no-use-before-define: 0 */
import jQuery from "jquery";

(function main($) {
    $(document).ready(() => {
        const desktopTopNavigation = $(".desktop-component-container .top-navigation").first();
        if (!desktopTopNavigation.hasClass("experience-editor") && !desktopTopNavigation.hasClass("preview")
                 && desktopTopNavigation.length > 0) {
            appendTopPaddingToBody(desktopTopNavigation);

            let wasVisiblePreviously = desktopTopNavigation.is(":visible");
            let resizeTimeoutId;
            $(window).resize(() => {
                window.clearTimeout(resizeTimeoutId);
                resizeTimeoutId = window.setTimeout(resizeEventListener, 100);
            });

            let scrollPrevious = $(window).scrollTop();
            if (desktopTopNavigation.is(":visible")) {
                window.addEventListener("scroll", scrollEventListener);
            }

            // eslint-disable-next-line no-inner-declarations
            function scrollEventListener() {
                scrollPrevious = setScrollStyles(desktopTopNavigation, scrollPrevious);
            }

            // eslint-disable-next-line no-inner-declarations
            function resizeEventListener() {
                const isCurrentlyVisible = desktopTopNavigation.is(":visible");
                if (isCurrentlyVisible !== wasVisiblePreviously) {
                    if (isCurrentlyVisible) {
                        scrollPrevious = $(window).scrollTop();
                        window.addEventListener("scroll", scrollEventListener);
                    } else {
                        window.removeEventListener("scroll", scrollEventListener);
                    }
                }
                wasVisiblePreviously = isCurrentlyVisible;
                appendTopPaddingToBody(desktopTopNavigation);
            }
        }
    });

    function setScrollStyles(topNavigation, scrollPrevious) {
        const elTop = parseInt(topNavigation.css("top"), 10);
        const scrollCurrent = $(window).scrollTop();
        const scrollDiff = scrollPrevious - scrollCurrent;
        // scrolled to the very top; element sticks to the top
        if (scrollCurrent <= 0) {
            topNavigation.css("top", "0");
        } else if (scrollDiff > 0) { // scrolled up; element slides in
            topNavigation.css("top", `${elTop + scrollDiff <= 0 ? elTop + scrollDiff : 0}px`);
        } else if (scrollDiff < 0) { // scrolled down
            // scrolled to the very bottom; element slides in
            if (scrollCurrent + $(window).height() >= $(document).height() - topNavigation.height()) {
                const newElTop = scrollCurrent + $(window).height() - $(document).height();
                topNavigation.css("top", `${newElTop < 0 ? newElTop : 0}px`);
            } else { // scrolled down; element slides out
                const newTopValue = elTop + scrollDiff >= -topNavigation.height()
                    ? elTop + scrollDiff
                    : -topNavigation.height();
                topNavigation.css("top", `${newTopValue}px`);
            }
        }
        return scrollCurrent;
    }

    function appendTopPaddingToBody(desktopTopNavigation) {
        if (desktopTopNavigation == null) {
            return;
        }
        if (desktopTopNavigation.is(":visible")) {
            $("body").css("padding-top", `${desktopTopNavigation.height() - 2}px`);
        } else {
            $("body").css("padding-top", 0);
        }
    }
}(jQuery));
